<template>
  <div class="login-wrap"
       ref="fullscreenContainer" v-loading="loding">
    <div class="formContainer">
      <div class="formLeft">
        <img src="../images/logo.png" >
      </div>
      <div class="formRight">
        <form id="login">
          <header>
            <h3>晨鸟科技后台管理平台</h3>
          </header>
          <section>
            <label>
              <p>用户名</p>
              <input type="text"
                     placeholder=" "
                     style="border: none;"
                     v-model="username">
              <div class="border"></div>
            </label>
            <label>
              <p>密码</p>
              <input type="password"
                     placeholder=" "
                     v-model="password">
              <div class="border"></div>
            </label>
            <el-button type="primary"
                       @click="submitForm()">登 录</el-button>
          </section>

        </form>
      </div>
    </div>
    <div class="foot"
         style="text-align:right;font-size: 30px; ">
      <!-- <a style="color: white;" href="https://beian.miit.gov.cn/#/Integrated/recordQuery"> 鄂ICP备2021013747号-1鄂ICP备2021013747号-1</a> -->
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs"
import screenfull from 'screenfull'
export default {
  data () {
    return {
      username: "",
      password: "",
      param: {
        username: "",
        password: "",
      },
      year: '',
      title: 'Copyright ©2004-2023 晨鸟科技 版权所有 沪ICP备09012675号-1',
      ticket:'',
      loding : false
    };
  },

  created () {
    this.year = new Date();
    this.year = this.year.getFullYear()
  },
  methods: {
    // 全屏
    onFullScreen () {
      if (!screenfull.isFullscreen) {
        screenfull.toggle(); // 开启全屏
      }
    },
    submitForm () {
     // this.onFullScreen();
      if (this.username == "") {
        this.$message.error("请输入账号");
        return false;
      } else if (this.password == "") {
        this.$message.error("请输入密码");
        return false;
      }
      let params = {
        username: this.username,
        password: this.password,
      };
      this.$http.post("User/Login", params).then((res) => {
        if (res.success) {
          localStorage.setItem("ms_username", this.username);
            localStorage.setItem("accessToken", res.tnToken.tokenStr);
            localStorage.setItem("tokenStartTime", res.tnToken.expires);
            localStorage.setItem("uid", res.dynamicObj.id);
            // this.$store.dispatch("getgroup").then((res) => {
            //   console.log(res);
            //   this.islogin = false;
            //   this.$router.push("/");
            //   this.$message.success("登录成功");
            // });
            this.$router.push("/NewsInformation");
            this.$message.success("登录成功");
        } else {
          this.$message.warning(res.message);
        }
      });

    },
  },
};
</script>

<style scoped>
.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  /* background-image: url(../images/login.jpg); */
  /* background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    url(../images/login.jpg) no-repeat 0% 20% / cover; */

  background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
     url(../images/login.jpg) no-repeat 0% 20% / cover; 
     /* url(../images/HqLogin.jpeg) no-repeat 0% 20% / cover;*/

  background-size: 100%;
  /* opacity: 0.8; */
}

/* .ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #2b89f9;
  border-bottom: 1px solid #ddd;
}

.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 350px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;
  background: #e1f3d8;
  overflow: hidden;
} */
.foot {
  position: absolute;
  top: 95%;
  left: 40%;
  overflow: hidden;
}

.formContainer {
  position: absolute;
  left: 35%;
  top: 32%;
  display: flex;
  transition: 0.2s ease;
  height: 342.5px;
  transition-delay: 0.3s;
}

.formContainer.toggle {
  height: 480px;
  transition-delay: 0s;
}

.formLeft {
  background: #fff;
  border-radius: 5px 0 0 5px;
  padding: 0 35px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.formLeft img {
  display: block;
  width: 72px;
  /* border-radius: 50%; */
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.formRight {
  position: relative;
  overflow: hidden;
  border-radius: 0 5px 5px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.formRight:before {
  content: "";
  position: absolute;
  top: -10px;
  left: -10px;
  width: calc(100% + 20px);
  height: calc(100% + 20px);
  /* background: url("../images/bg.jpg") center/cover fixed; */
  box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.5);
  filter: blur(5px);
}

.formRight form {
  position: relative;
  width: 350px;
  padding: 25px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
}

.formRight form header {
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.formRight form header h1 {
  margin: 0;
  font-weight: 400;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.formRight form header p {
  margin: 5px 0 0;
  opacity: 0.5;
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.formRight form section label {
  display: block;
  margin-bottom: 15px;
  position: relative;
}

.formRight form section label p {
  color: #fff;
  margin: 0 0 10px 0;
  font-weight: 600;
  font-size: 12px;
  opacity: 0.5;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.formRight form section label input {
  width: 100%;
  display: block;
  border: none;
  background: transparent;
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0 0 10px;
  box-sizing: border-box;
  font-weight: 600;
}

.formRight form section label input:focus ~ .border {
  transform: scale(1, 1);
}

.formRight form section label input:not(:-moz-placeholder-shown) ~ .border {
  transform: scale(1, 1);
}

.formRight form section label input:not(:-ms-input-placeholder) ~ .border {
  transform: scale(1, 1);
}

.formRight form section label input:not(:placeholder-shown) ~ .border {
  transform: scale(1, 1);
}

.formRight form section label .border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #fff;
  transform: scale(0, 1);
  transition: 0.2s ease;
}

.formRight form section label:last-child {
  margin-bottom: 0;
}

.formRight form section button {
  background: #00897b;
  border: none;
  width: 100%;
  padding: 10px 0;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

.formRight form section button:hover {
  background: #007f72;
}

.formRight form footer {
  margin-top: 15px;
  display: flex;
}

.formRight form footer button {
  background: transparent;
  padding: 0;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  flex: 1;
  opacity: 0.5;
}

.formRight form footer button:hover {
  opacity: 1;
}

.formRight form.otherForm {
  top: 0;
  left: 0;
  position: absolute;
  background: #fff;
  height: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 0;
  padding: 25px 0;
  transition: 0.2s ease;
  transition-delay: 0.2s;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
}

.formRight form.otherForm header {
  color: #000;
  opacity: 0;
  transition: 0.2s ease;
  transition-delay: 0s;
}

.formRight form.otherForm p {
  color: #000;
}

.formRight form.otherForm section {
  opacity: 0;
  transition: 0.2s ease;
  transition-delay: 0s;
}

.formRight form.otherForm footer {
  border-top-color: rgba(0, 0, 0, 0.1);
  opacity: 0;
}

.formRight form.otherForm footer button {
  color: #000;
}

.formRight form.otherForm input {
  border-color: rgba(0, 0, 0, 0.1);
  color: #000;
}

.formRight form.otherForm .border {
  background: #000;
}

.formRight form.otherForm.toggle {
  width: 100%;
  padding: 25px;
  transition-delay: 0s;
}

.formRight form.otherForm.toggle header,
.formRight form.otherForm.toggle section,
.formRight form.otherForm.toggle footer {
  opacity: 1;
  transition-delay: 0.3s;
}
</style>
